var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "price-wrapper" }, [
    _c("div", [
      _c("div", { staticClass: "base-price-wrapper" }, [
        _vm.tileBasePrice
          ? _c("div", { staticClass: "d-flex flex-wrap align-items-center" }, [
              _c("span", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.tileBasePrice + "/mois",
                    expression: "tileBasePrice + '/mois'",
                  },
                ],
                staticClass: "p my-0 fw-bold text-decoration-line-through",
                class: _vm.isBlack ? "text-white" : "text-dark",
              }),
              _vm._v(" "),
              _vm.tileTotalDiscountsAndOdrAmount
                ? _c(
                    "div",
                    {
                      staticClass: "ob1-tag ob1-tag-small ob1-tag-primary",
                      staticStyle: { "margin-left": "10px" },
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: _vm.tileTotalDiscountsAndOdrAmount + "/mois",
                            expression:
                              "tileTotalDiscountsAndOdrAmount + '/mois'",
                          },
                        ],
                        staticClass: "p my-0",
                      }),
                      _vm._v(" "),
                      _vm.clientTagLabel
                        ? _c("span", [_vm._v(_vm._s(_vm.clientTagLabel))])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "final-price-wrapper" },
        [
          _c("Price", {
            attrs: {
              price: _vm.tileFinalPrice,
              "initial-price": _vm.tileFinalPricePermanent,
              "price-details": _vm.price.priceDetails ?? undefined,
              duration: _vm.tileDuration,
              "is-cents-format": false,
              "is-compact": true,
              "is-inverse": _vm.isBlack,
              "show-from": _vm.price.showFrom,
              "show-by-month": _vm.price.showByMonth,
              "show-promo-duration": _vm.price.showPromoDuration,
              "show-promo-duration-first-months":
                _vm.price.showPromoDurationFirstMonths,
              "show-end-of-promotion-price": _vm.price.showEndOfPromotionPrice,
              "show-children-promotion-price":
                _vm.price.showChildrenPromotionPrice,
              "cashback-type": _vm.cashbackType,
            },
          }),
          _vm._v(" "),
          _vm.priceDetailsPopin && _vm.priceDetailsPopin.linkLabel
            ? _c(
                "div",
                [
                  _c("Lien", {
                    attrs: {
                      label: _vm.priceDetailsPopin.linkLabel,
                      "is-inverse": _vm.isBlack,
                      "is-button": true,
                      "data-test-id": "btn-price-detail-" + _vm.offerIdSeo,
                      "modal-id": _vm.isEmbeddedDetails
                        ? ""
                        : "price-details-popin-" + _vm.offerIdSeo,
                      "tms-category": _vm.trackingCategory,
                      "tms-action": _vm.priceDetailsPopin.linkLabel,
                      "tms-label": _vm.offerName,
                    },
                    on: { click: _vm.showDetails },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }